var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLowVolume = function SvgLowVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "low-volume_svg__Layer_1",
    width: 20,
    height: 20,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d5-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.68 10a2.83 2.83 0 0 1 0 4M1.5 8.25h4.69v7.5H1.5z",
    className: "cls-6374f543b67f094e4896c5d5-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.69 3.56v16.88h-1.64l-5.86-4.69v-7.5l5.86-4.69z",
    className: "cls-6374f543b67f094e4896c5d5-1"
  })));
};
export default SvgLowVolume;